import React, { useState } from "react";
import {
  Image,
  Button,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@heroui/react";
import { LogOut, Wallet } from "lucide-react";
import { useGetUserData } from "../../hooks/useGetUserData";
import createBlockies from "ethereum-blockies-base64";
import { logout } from "@multiversx/sdk-dapp/utils";
import { useGetA1XBalance } from "../../hooks/useGetAccountTokens";

export const UserInfo: React.FC = () => {
  const { userData, isLoading } = useGetUserData();
  const { data: a1xData } = useGetA1XBalance();
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);

  if (isLoading || !userData) {
    return null;
  }

  const formatBalance = (balance: string | undefined) => {
    if (!balance) return "0";
    const num = parseFloat(balance);
    return num.toLocaleString('en-US', { 
      minimumFractionDigits: 3,
      maximumFractionDigits: 3 
    });
  };

  const blockyAvatar = createBlockies(userData.address);

  const handleLogout = () => {
    // Close the modal first
    setLogoutModalOpen(false);

    logout();
  };

  return (
    <>
      <div className="flex items-center gap-2 p-1 dark">
        {/* Gold - Hidden on mobile */}
        {/* <div className="hidden md:flex bg-black/10 border border-neutral-700/30 items-center gap-1.5 px-2 py-1 rounded-md">
          <Image
            src={IMAGES.GOLD}
            alt="Gold"
            className="h-4 w-4 object-contain"
          />
          <span className="text-white font-medium text-sm">
            {userData.gold}
          </span>
        </div> */}

        {/* Gems - Hidden on mobile */}
        {/* <div className="hidden md:flex bg-black/10 border border-neutral-700/30 items-center gap-1.5 px-2 py-1 rounded-md">
          <Image
            src={IMAGES.GEMS}
            alt="Gems"
            className="h-4 w-4 object-contain"
          />
          <span className="text-white font-medium text-sm">
            {userData.gems}
          </span>
        </div> */}

        {/* A1X Balance Card */}
        <div className="bg-content1 border border-divider rounded-lg flex items-center gap-1.5 px-3 py-1.5 shadow-sm h-[38px]">
          <Wallet size={16} className="text-default-500" />
          <span className="text-white font-medium text-sm">
            {formatBalance(a1xData?.formattedBalance)}
          </span>
          <span className="text-primary font-semibold text-sm">A1X</span>
        </div>
        
        {/* User Avatar & Logout */}
        <div className="bg-content1 border border-divider rounded-lg flex items-center gap-1.5 px-3 py-1.5 shadow-sm">
          <div className="h-6 w-6 rounded-md overflow-hidden">
            <img
              src={blockyAvatar}
              alt="User Avatar"
              className="h-full w-full"
            />
          </div>
          <Button
            isIconOnly
            size="sm"
            variant="light"
            className="text-default-500 hover:text-default-700 m-0 h-5 w-5 min-w-0 p-0 border-0"
            onPress={() => setLogoutModalOpen(true)}
          >
            <LogOut size={14} />
          </Button>
        </div>
      </div>

      {/* Logout Confirmation Modal */}
      <Modal
        isOpen={logoutModalOpen}
        onOpenChange={setLogoutModalOpen}
        placement="top-center"
        className="dark"
        classNames={{
          closeButton: "dark bg-neutral-800 border-0",
        }}
        size="xs"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="text-white">Confirm Logout</ModalHeader>
              <ModalBody>
                <p className="text-neutral-300 text-sm">
                  Are you sure you want to disconnect your wallet?
                </p>
              </ModalBody>
              <ModalFooter>
                <Button className="bg-neutral-800 text-white" onPress={onClose}>
                  Cancel
                </Button>
                <Button
                  className="bg-primary text-white"
                  onPress={handleLogout}
                >
                  Logout
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};
